import { render, staticRenderFns } from "./ClientesTable.vue?vue&type=template&id=aeda4dcc"
import script from "./ClientesTable.vue?vue&type=script&lang=ts"
export * from "./ClientesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports